import sanitize from '../../../utilities/parseHTML/purify';
import parseHTML from '../../../utilities/parseHTML';
import defaultImageAlt from '../../../utilities/defaultImageAlt';
import * as buildSpecs from '../../../context/build/Constants.json';

const isJsonString = (str) =>
{
    try
    {
        JSON.parse(str);
    }
    catch (e)
    {
        return false;
    }
    return true;
}


const doParse = (el, shouldSanitize) =>
    shouldSanitize ? parseHTML(el, ['learningCenter']).parsed : el;

const relatedArticlesPropsTransformer = (props) =>
{
    const { title, relatedPosts, handlePageChange, currentPage, slug } = props;

    const posts = relatedPosts
        ?.map(({ node }) => ({ ...node }))
        ?.map((post) =>
        {
            let imgAltText;
            const sanitizedTitle = post?.title
                ? doParse(post?.title, true)
                : '';

            if (!post?.featuredImage )
            {
                const metadata =
                    post?.cdmfields?.legacymeta?.qlmigArticleImageMetadata;
                let parsedAlt = '';
                if (metadata && isJsonString(metadata))
                {
                    parsedAlt = JSON.parse(metadata)?.alternateText;
                }
                imgAltText =
                    sanitize(parsedAlt) ||
                    defaultImageAlt(sanitizedTitle, 'postTitle');
            }
            else
            {
                imgAltText =
                    sanitize(post?.featuredImage?.node?.altText) ||
                    defaultImageAlt(sanitizedTitle, 'postTitle');
            }

            return {
                readingtime: sanitize(post?.cdmfields?.readingtime?.minutes || ''),
                databaseId: sanitize(post?.databaseId || ''),
                link: sanitize(post?.uri || ''),
                title: parseHTML(post?.title || '', ['learningCenter']).parsed,
                imgPath: post?.featuredImage || post?.cdmfields?.legacymeta?.qlmigArticleImage,
                gatsbyImage: post?.featuredImage?.node,
                imgAltText,
            };
        });
    const articleListProps = {
        queryArgs: {
            posts,
            total_found: relatedPosts?.length || 0,
        },
        gridLimit: handlePageChange ? buildSpecs.BUILD.defaults.POSTS_PER_PAGE : 3,
        handlePageChange,
        currentPage,
        showControl: false,
    };

    return {
        title,
        slug: (typeof window !== 'undefined') ? `${window.location.href}/${slug}` : `${slug}`,
        articleListProps,
    };
};

export default relatedArticlesPropsTransformer;
